// extracted by mini-css-extract-plugin
module.exports = {"main":"Overflow_main__26RTv","fade":"Overflow_fade__2hOpN"};